export const v2Url = process.env.REACT_APP_API_PREFIX_URL?.replace('v1', 'v2');
export const adminUrl = process.env.REACT_APP_API_PREFIX_URL?.replace('v1', 'admin');
